const generalInformation = {
	AppName: 'Skopei Connect',

	// This is bad, but due to current backend setup we need to hardcode it for now.
	// If it doesn't get resolved somehow, we at least need to make a mapping per environment.
	// Currently this has id 1 in all environments.
	// In the future, the whole concept of a special organisation being the one that has unassigned
	// devices will be retired and we'll have a proper handling of whether a device is unassigned
	// or not.
	manufacturingOrganisationId: '1',
	isProduction: import.meta.env.VITE_APP_ENV === 'production',
} as const;

export default generalInformation;
